import { render } from "./ProductModalSide.vue?vue&type=template&id=4149ee5b"
import script from "./ProductModalSide.vue?vue&type=script&lang=js"
export * from "./ProductModalSide.vue?vue&type=script&lang=js"

import "./ProductModalSide.vue?vue&type=style&index=0&id=4149ee5b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__